import React, { useState, useEffect } from "react";

const TypographyInput = ({ label, inputValue, inputs, setInputs }) => {
  const [typographyInput, setTypographyInput] = useState("");

  function handleInputChange(typographyInput) {
    setTypographyInput(typographyInput);
    setInputs({ ...inputs, ...{ [label]: typographyInput } });
  }

  useEffect(() => {
    if (inputValue) {
      setTypographyInput(inputValue);
    }
  }, [inputValue]);

  function renderInput() {
    const dropDownValues = [1.125, 1.2, 1.25, 1.33, 1.414, 1.5, 1.618];

    if (label.includes("Modular Scale")) {
      const selectData = dropDownValues.map((item) => {
        return (
          <option key={item} value={item}>
            {item}
          </option>
        );
      });

      return (
        <select
          className="typography-input"
          onChange={(e) => handleInputChange(e.target.value)}
          value={typographyInput}>
          {selectData}
        </select>
      );
    } else {
      return (
        <input
          className="typography-input"
          type="text"
          value={typographyInput}
          onChange={(e) => handleInputChange(e.target.value)}></input>
      );
    }
  }

  return (
    <div className="typography-input-container">
      <div className="typography-input-label">{label}</div>
      {renderInput()}
    </div>
  );
};

export default TypographyInput;
